import React from 'react';

export const ToastCloseButton = ({ closeToast }) => (
    <i className="material-icons close" onClick={closeToast}>
        close
    </i>
);
